import React from 'react'
import {Message, Popup, Button, Icon} from 'semantic-ui-react'
import {copyToClipboard} from '../copy-to-clipboard'
import StyleNumberError from '../style-number-error'

const styleNumberMessage = (familyId, color, pattern, season) => {
  let styleNumber = 'P' + familyId.padStart(4,'0') + '-' + color.padStart(3,'0') + '-' + pattern + season

  return (
    <center>
      <Message info style={{display: 'inline-block', fontSize: '200%'}}>
        <Message.Header id="new-style-number-print">
<Popup position='bottom center' content='Prints always start with P' trigger={<span style={{cursor: 'pointer'}}>P</span>} />
<Popup position='bottom center' content='Family Id' trigger={<span style={{cursor: 'pointer'}}>{familyId.padStart(4,'0')}</span>} />
-<Popup position='bottom center' content='Color' trigger={<span style={{cursor: 'pointer'}}>{color.padStart(3,'0')}</span>} />-
<Popup position='bottom center' content='Pattern' trigger={<span style={{cursor: 'pointer'}}>{pattern}</span>} />
<Popup position='bottom center' content='Season' trigger={<span style={{cursor: 'pointer'}}>{season}</span>} />
        </Message.Header>
        <StyleNumberError styleNumber={styleNumber} type={'PRINT'}/>
      </Message>
      <Button basic style={{marginLeft: '20px'}} onClick={() => copyToClipboard(true)}>Copy to clipboard &nbsp;<Icon name='clipboard outline'/></Button>
    </center>
  )
}

export {styleNumberMessage}
